<template>
    <div class="mt-2">
        <v-form
            lazy-validation
            ref="form"
            v-model="valid">
            <!-- display mode -->
            <v-card class="content-container d-flex-space-between" v-if="!isEditing">
                <v-container>
                    <v-row class="row-margin">
                        <v-col cols="7">
                            <div class="header-box">
                                <v-row>
                                    <v-col>
                                        <div class="profile-header d-flex-space-between">
                                            <span class="ml-4 mt-3 locale-font">
                                                {{ $vuetify.lang.t('$vuetify.companyProfile.profile') }}
                                            </span>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-2 no-warp">
                                    <v-col
                                        cols="3"
                                        class="profile-company-image">
                                        <upload-image
                                            :isEditing="false"
                                            :img="checkImg(form.companyLogo)"/>
                                    </v-col>
                                    <v-col>
                                        <v-row>
                                            <v-col class="label-header">
                                                <label class="locale-font"> {{ $vuetify.lang.t('$vuetify.companyProfile.companyName') }} </label>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col class="label-text">
                                                <label class="locale-font-text"> {{ $vuetify.lang.t('$vuetify.companySetting.nbtc') }} </label>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col class="label-header">
                                                <label class="locale-font"> {{ $vuetify.lang.t('$vuetify.companyProfile.hqAddress') }} </label>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col class="label-text">
                                                <label class="locale-font-text"> {{ checkStr(form.hqAddress) }} </label>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col class="label-header">
                                                <label class="locale-font"> {{ $vuetify.lang.t('$vuetify.companyProfile.businessDescription') }} </label>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col class="label-text">
                                                <label class="locale-font-text"> {{ checkStr(form.businessDescription) }} </label>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                        <v-col
                            cols="5">
                            <div class="header-box">
                                <v-row>
                                    <v-col>
                                        <div class="profile-header d-flex-space-between">
                                            <span class="mt-3 locale-font">
                                                {{ $vuetify.lang.t('$vuetify.companyProfile.contact') }}
                                            </span>
                                            <v-btn
                                                v-if="!isEditing && canUpdate"
                                                @click="toggleEdit()"
                                                outlined
                                                width="180"
                                                height="50"
                                                color="primary">
                                                <v-icon
                                                    class="pr-2">
                                                    edit
                                                </v-icon>
                                                {{ $vuetify.lang.t('$vuetify.companyProfile.edit') }}
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-2">
                                    <v-col>
                                        <v-row>
                                            <v-col>
                                                <v-row>
                                                    <v-col class="label-header">
                                                        <label class="locale-font"> {{ $vuetify.lang.t('$vuetify.companyProfile.fullName') }} </label>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col class="label-text">
                                                        <label class="locale-font-text"> {{ checkStr(form.contact_fullname) }} </label>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-row>
                                                    <v-col class="label-header">
                                                        <label class="locale-font"> {{ $vuetify.lang.t('$vuetify.companyProfile.email') }} </label>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col class="label-text">
                                                        <label class="locale-font-text"> {{ checkStr(form.contact_email) }} </label>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-row>
                                                    <v-col class="label-header">
                                                        <label class="locale-font"> {{ $vuetify.lang.t('$vuetify.companyProfile.phoneNumber') }} </label>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col class="label-text">
                                                        <label class="locale-font-text"> {{ `(${nationalTelCode}) ${form.contact_number}` }} </label>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>

            <!-- edit mode -->
            <v-card class="content-container" v-else>
                <v-container>
                    <v-row>
                        <v-col
                            cols="7">
                            <v-container class="header-box">
                                <v-row>
                                    <v-col>
                                        <div class="profile-header">
                                            <span class="ml-4 mt-3 locale-font">
                                                {{ $vuetify.lang.t('$vuetify.companyProfile.profile') }}
                                            </span>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row class="no-warp">
                                    <v-col
                                        cols="3"
                                        class="profile-company-image">
                                        <upload-image
                                            :isEditing="isEditing"
                                            @change-profile-img="changeProfileImg"
                                            @remove-img="removeProfileImg"
                                            :img="checkImg(form.companyLogo)"/>
                                    </v-col>
                                    <v-col>
                                        <v-row>
                                            <v-col>
                                                <v-text-field
                                                    class="readonly"
                                                    :label="$vuetify.lang.t('$vuetify.companyProfile.companyName')"
                                                    :value="$vuetify.lang.t('$vuetify.companySetting.nbtc')"
                                                    autocomplete="off"
                                                    placeholder=" "
                                                    readonly>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-textarea
                                                    :label="$vuetify.lang.t('$vuetify.companyProfile.hqAddress')"
                                                    v-model="form.hqAddress"
                                                    rows="2"
                                                    autocomplete="off"
                                                    placeholder=" "
                                                    no-resize
                                                    :readonly="!isEditing">
                                                </v-textarea>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-textarea
                                                    :label="$vuetify.lang.t('$vuetify.companyProfile.businessDescription')"
                                                    v-model="form.businessDescription"
                                                    rows="2"
                                                    autocomplete="off"
                                                    placeholder=" "
                                                    no-resize
                                                    :readonly="!isEditing">
                                                </v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                        <v-col
                            cols="5">
                            <div class="header-box-edit">
                                <v-row>
                                    <v-col>
                                        <div class="profile-header">
                                            <span class="mt-3 locale-font">
                                                {{ $vuetify.lang.t('$vuetify.companyProfile.contact') }}
                                            </span>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-row>
                                            <v-col
                                                cols="6">
                                                <v-text-field
                                                    :label="$vuetify.lang.t('$vuetify.companyProfile.firstName')"
                                                    v-model="form.contact_firstname"
                                                    autocomplete="off"
                                                    placeholder=" "
                                                    :readonly="!isEditing"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                    :label="$vuetify.lang.t('$vuetify.companyProfile.lastName')"
                                                    v-model="form.contact_lastname"
                                                    autocomplete="off"
                                                    placeholder=" "
                                                    :readonly="!isEditing"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-text-field
                                                    :label="$vuetify.lang.t('$vuetify.companyProfile.email')"
                                                    v-model="form.contact_email"
                                                    autocomplete="on"
                                                    placeholder=" "
                                                    :readonly="!isEditing"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-text-field
                                                    :label="$vuetify.lang.t('$vuetify.companyProfile.phoneNumber')"
                                                    v-model="form.contact_number"
                                                    autocomplete="off"
                                                    placeholder=" "
                                                    v-mask = "'## ### ####'"
                                                    :prefix="`(${nationalTelCode})`"
                                                    :readonly="!isEditing"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>

            <div class="flex-btn mt-8" v-if="isEditing">
                <v-btn
                    @click="cancel()"
                    outlined
                    class="mr-4"
                    width="180"
                    height="50"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.companyProfile.cancel') }}
                </v-btn>
                <v-btn
                    @click="save()"
                    width="180"
                    height="50"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.companyProfile.save') }}
                </v-btn>
            </div>
        </v-form>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import UploadImage from '@/components/UploadImage'
import profileDefault from '@/assets/user_default.png'

export default {
    name: 'CompanyProfile',
    components: {
        UploadImage
    },

    directives: {
        mask
    },

    data () {
        return {
            valid: true,
            isEditing: false,
            form: {
                companyName: '',
                hqAddress: '',
                businessDescription: '',
                companyLogo: '',
                contact_fullname: '',
                contact_firstname: '',
                contact_lastname: '',
                contact_email: '',
                contact_number: ''
            },
            nationalTelCode: '+66',
            tmpForm: {},
            errors: {},
            canUpdate: false
        }
    },

    methods: {
        toggleEdit () {
            this.tmpForm = JSON.parse(JSON.stringify(this.form))
            this.isEditing = !this.isEditing
        },

        async getCompanyInfo () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.get('company/get')
            if (res && res.data && res.data.status === 'ok') {
                this.form.companyName = res.data.data.name
                this.form.hqAddress = res.data.data.address
                this.form.businessDescription = res.data.data.description
                this.form.companyLogo = res.data.data.f_path
                this.form.contact_firstname = res.data.data.contact_firstname
                this.form.contact_lastname = res.data.data.contact_lastname
                this.form.contact_fullname = (`${this.form.contact_firstname} ${this.form.contact_lastname}`).trim()
                this.form.contact_email = res.data.data.contact_email
                this.form.contact_number = res.data.data.contact_number.slice(3)
            }
            this.$store.dispatch('setLoading', false)
        },

        changeProfileImg (event) {
            const fileList = event.target.files

            const reader = new FileReader()
            let imgBase64 = null

            if (fileList[0]) {
                reader.onload = () => {
                    imgBase64 = reader.result
                    this.form.companyLogo = imgBase64
                }

                reader.readAsDataURL(fileList[0])
            }
        },

        removeProfileImg () {
            this.form.companyLogo = null
        },

        cancel () {
            this.form = JSON.parse(JSON.stringify(this.tmpForm))
            this.isEditing = false
            this.errors = {}
        },

        async save () {
            this.$store.dispatch('setLoading', true)

            const form = {
                name: this.form.companyName.trim(),
                contact_number: `${this.nationalTelCode} ${this.form.contact_number}`
            }
            if (this.form.companyLogo) {
                if (this.form.companyLogo !== this.tmpForm.companyLogo) {
                    form.image = this.form.companyLogo
                }

                const res = await this.axios.put('company/edit', form)
                if (res && res.data && res.data.status === 'ok') {
                    this.checkForUpdatingCompanyProfileImg()
                    this.toggleEdit()
                    this.$store.dispatch('setLoading', false)

                    this.$refs.form.resetValidation()
                    this.errors = {}

                    this.$notify({
                        title: this.$vuetify.lang.t('$vuetify.companyProfile.congratulation'),
                        text: this.$vuetify.lang.t('$vuetify.companyProfile.companyProfileIsUpdated'),
                        type: 'success'
                    })
                }
            } else {
                this.$store.dispatch('setLoading', false)
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.companyProfile.errorMessage'),
                    text: this.$vuetify.lang.t('$vuetify.companyProfile.imageCannotBeNull'),
                    type: 'error'
                })
            }
        },

        checkForUpdatingCompanyProfileImg () {
            if (this.form.companyLogo !== this.tmpForm.companyLogo) {
                this.$store.dispatch('changeCompanyProfileImg', this.checkImg(this.form.companyLogo))
            }
        },

        checkStr (str) {
            return (str && str.trim() !== '') ? str.trim() : '-'
        },

        checkImg (img) {
            return img || profileDefault
        }
    },

    async mounted () {
        this.canUpdate = await this.hasPermission(this.$constant.permission.COMPANY_SETTING.UPDATE)
        await this.getCompanyInfo()
        this.$refs.form.resetValidation()
    }
}
</script>

<style lang="scss" scoped>
.flex-btn {
    display: flex;
    justify-content: flex-end;
}
.profile-header {
    font-size: 24px;
    min-height: 50px;
}
.profile-company-image {
    display: flex;
    justify-content: left;
    margin-top: 1.5rem;
}
.contact-card {
    height: 516px;
}
.label-header {
    font-weight: 300;
    font-size: 14px !important;
    color: #6c6c6c !important;
}
.label-text {
    font-weight: 400;
    font-size: 16px !important;
    color: #131410 !important;
    padding-top: 3px !important;
}
.d-flex-space-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.header-box {
    padding: 10px 0px 10px 20px !important;
}
.header-box-edit {
    padding: 10px 40px 10px 20px !important;
}
.row-margin {
    margin: -12px 0px 0px 0px;
}
.no-warp {
    flex-wrap: nowrap !important;
}

::v-deep .readonly .v-input__slot {
    cursor: default !important;
    background-color: rgba(0, 0, 0, 0.06);

    & * {
        cursor: default !important;
    }

    &:hover {
        background-color: rgba(0, 0, 0, 0.12);
    }
}
</style>
